export function Icon({ name }) {
  const common = { className: "icon", "aria-hidden": "true", viewBox: "0 0 24 24" };
  switch (name) {
    case "spark":
      return (
        <svg {...common}>
          <path
            fill="currentColor"
            d="M12 2l1.4 6.2L20 10l-6.6 1.8L12 18l-1.4-6.2L4 10l6.6-1.8L12 2z"
          />
        </svg>
      );
    case "shield":
      return (
        <svg {...common}>
          <path
            fill="currentColor"
            d="M12 2l8 4v7c0 5-3.4 9.4-8 10-4.6-.6-8-5-8-10V6l8-4zm0 5.2L7 8.9V13c0 3.6 2.2 6.8 5 7.7 2.8-.9 5-4.1 5-7.7V8.9l-5-1.7z"
          />
        </svg>
      );
    case "bolt":
      return (
        <svg {...common}>
          <path fill="currentColor" d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
        </svg>
      );
    case "wand":
      return (
        <svg {...common}>
          <path
            fill="currentColor"
            d="M3 21l9-9 3 3-9 9H3zm10.2-10.8l5.5-5.5a2 2 0 0 1 2.8 2.8l-5.5 5.5-2.8-2.8zM6 5l1.2 2.4L10 8.6 7.2 9.8 6 12.2 4.8 9.8 2.4 8.6 4.8 7.4 6 5zm10-3l1.2 2.4L20 5.6 17.2 6.8 16 9.2 14.8 6.8 12.4 5.6 14.8 4.4 16 2z"
          />
        </svg>
      );
    default:
      return null;
  }
}

